/// Menu
import Metismenu from "metismenujs";
import React, { Component, useContext, useEffect, useState } from "react";
import PerfectScrollbar from "react-perfect-scrollbar";
import { connect, useDispatch } from "react-redux";
import { Link, useLocation, withRouter } from "react-router-dom";
import useScrollPosition from "use-scroll-position";
import { ThemeContext } from "../../../context/ThemeContext";
import "../../../css/sidebar.scss";
import SidebarMenu from "../../../utils/menu";
import { translate } from "../../../utils/translate";

class MM extends Component {
  componentDidMount() {
    this.$el = this.el;
    this.mm = new Metismenu(this.$el);
  }
  componentWillUnmount() {
  }
  render() {
    return (
      <div className="mm-wrapper">
        <ul className="metismenu" ref={(el) => (this.el = el)}>
          {this.props.children}
        </ul>
      </div>
    );
  }
}

const SideBar = (props) => {
  const {
    iconHover,
    sidebarposition,
    headerposition,
    sidebarLayout,
  } = useContext(ThemeContext);
  const [path, setPath] = useState("/");
  const [renderMenuLoading, setRenderMenuLoading] = useState(true);
  const location = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    var btn = document.querySelector(".nav-control");
    var navBackdrop = document.querySelector(".navigation-backdrop-control");
    var aaa = document.querySelector("#main-wrapper");
    btn.addEventListener("click", () => toggleMenuFunc());
    navBackdrop.addEventListener("click", () => toggleMenuFunc(true));
  }, []);

  useEffect(() => {
    setTimeout(() => {
      setRenderMenuLoading(false);
    }, 500);
  }, [])

  const toggleMenuFunc = (forceClose = false) => {
    var body = document.querySelector("body");
    var aaa = document.querySelector("#main-wrapper");
    var aaabackdrop = document.querySelector(".navigation-backdrop-control");
    // console.log(aaa.classList.contains("menu-toggle"), 'check');
    if (forceClose) {
      aaabackdrop.classList.add('d-none');
      aaa.classList.remove("menu-toggle");
      // body.classList.remove("fixedPosition");
      return;
    }
    if (aaa.classList.contains("menu-toggle")) {
      aaabackdrop.classList.add('d-none');
      aaa.classList.remove("menu-toggle");
      // body.classList.remove("fixedPosition");
      return;
    } else {
      aaabackdrop.classList.remove('d-none');
      aaa.classList.add("menu-toggle");
      // body.classList.remove("fixedPosition");
      return
    }
  }

  let scrollPosition = useScrollPosition();
  useEffect(() => {
    setPath(replaceIdInUrl(location.pathname));
  }, [location]);

  const closeMenu = (hasChildren) => {
    if (!hasChildren) {
      if (document.querySelector('body').getAttribute("data-sidebar-style") === 'overlay') {
        document.querySelector(".nav-control").click();
      }
    }
  }
  function replaceIdInUrl(url) {
    return url.replace(/\/\d+$/, '/:id');
  }

  return (
    <div
      className={`deznav ${iconHover} ${sidebarposition.value === "fixed" &&
        sidebarLayout.value === "horizontal" &&
        headerposition.value === "static"
        ? scrollPosition > 120
          ? "fixed"
          : ""
        : ""
        }`}
    >

      <PerfectScrollbar className="deznav-scroll">
        <div className="mobileLogo mt-5 mx-auto mb-md-0 mb-4">
          <img src={require('../../../images/logo/logo.png').default} className="img-fluid" alt="logo" />
        </div>
        {renderMenuLoading ? null : (
          <MM className="metismenu" id="menu">
            {SidebarMenu.map((parent, i) => (
              <li key={i} className={`${parent.display.includes('mobile') ? 'd-block d-lg-none d-md-none' : ''} mx-4 px-0 mb-1 w-100 mx-auto ${parent.allPath.includes(path) ? "mm-active mm-parent-active" : "main-menu"}`}>
                <Link className={`ai-icon w-90 px-3 px-md-3 text-capitalize mx-auto py-2`} to={parent.children.length > 0 ? "#" : parent.pathName} onClick={() => closeMenu(parent.children.length > 0 ? true : false)}>
                  <div className="d-flex align-items-center justify-content-between w-100 py-md-2 py-0">
                    <div className="d-flex align-items-center">
                      <img src={parent.inactiveImg} className="icon-inactive" alt={parent.menu} />
                      <img src={parent.activeImg} className="icon-active" alt={parent.menu} />
                      <span className={`nav-text parent font-weight-600 font-16 text-capitalize ms-3`}> {translate(props.lang, parent.menu)}</span>
                    </div>
                    {parent.children.length > 0 ? (
                      <svg xmlns="http://www.w3.org/2000/svg" width="10" height="15" viewBox="0 0 10 15" fill="none">
                        <path d="M1.03125 14.0488L7.96458 7.54883L1.03125 1.04883" stroke="#fff" strokeWidth="1.5" strokeLinecap="round" />
                      </svg>
                    ) : null}
                  </div>
                </Link>
                {parent.children.length > 0 ? (
                  <ul className={`submenu ${parent.allPath.includes(path) ? "mm-show" : "mm-collapse"}`}>
                    {parent.children.map((child, key) => (
                      <li key={key} className={`${child.allPath.includes(path) ? "menu-active" : "menu-inactive"}`} onClick={() => closeMenu(false)}>
                        <Link to={child.pathName} className="children-nav">
                          <span className={`font-weight-400 font-14 text-capitalize`}>{translate(props.lang, child.menu)}</span>
                        </Link>
                      </li>
                    ))}
                  </ul>
                ) : null}
              </li>
            ))
            }
          </MM>
        )}
      </PerfectScrollbar>
    </div>
  );
}

const mapStateToProps = state => {
  const { auth, i18n } = state;
  return {
    lang: i18n.lang,
    auth: auth,
  }
}
export default withRouter(connect(mapStateToProps)(SideBar));